import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';

import cross from '../assets/img/cross.png';
import lockedFile from '../assets/img/lockedFile.png';
import coffee from '../assets/img/coffee.png';
import tick from '../assets/img/tick.png';

class RightPopup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      closePopupOne: false
    }
  }

  hidePopup = () => {
    this.setState({ closePopupOne: true });
}

  render() {
    const { t } = this.props;
    const classPopup = this.props.closePopup || this.state.closePopupOne ? ["col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 closeHelper"] : ["col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 helper"];
    return (
      <div className={classPopup}>
        <div className="Card CardWithTimes">
          <span className="closeCard" onClick={e => this.hidePopup()}><img src={cross} alt="" /></span>
          <div className="tutoList">
            <span>
              <img src={lockedFile} alt="" />
              <span>{t("general.lockedFileTutoMsg")}</span>
            </span>
            <span>
              <img src={coffee} alt="" />
              <span>{t("general.coffeeTutoMsg")}</span>
            </span>
            <span>
              <img src={tick} alt="" />
              <span>{t("general.tickTutoMsg")}</span>
            </span>
          </div>
          <span className="lastMsg">{t("general.aboutTutoMsg")}</span>
        </div>
      </div>
    )
  }
}

export default withTranslation()(RightPopup)